import {WpClient} from "../utils/wp-client";

export enum StorageKeys {
    K1 = "k1",
    K2 = "k2",
    K3 = "k3"
}

// export type XUserKeys = { [key in keyof User]?: any }

export interface WpRestResponse {
    success: boolean
    errors?: string[]
}

export interface ResponseAnything extends WpRestResponse {
    var1?: number;
    var2?: string[];
}

/**
 * Options available for sorting properties in grid view (configurable in Admin.Centris.Requests per site)
 */
export enum PropertiesSortByOptions {
    UPDATED_ASC = 0,
    UPDATED_DESC = 1,
    PRICE_ASC = 2,
    PRICE_DESC = 3,
}